module.exports = __webpack_public_path__ + "img/tick.e2f26a2c.svg";